import React from "react";
import styles from "./style.module.scss";

export type Session = {
  _id: string;
  session: string;
  dt: string;
};

interface SessionsBarProps {
  sessions: Session[];
  selectedSessions: string[];
  onSelectionChange: (selected: string[]) => void;
  loading?: boolean;
  rightElement?: React.ReactNode;
}

const SessionsBar: React.FC<SessionsBarProps> = ({
  sessions,
  selectedSessions,
  onSelectionChange,
  loading = false,
  rightElement,
}) => {
  const handleToggle = (id: string) => {
    if (selectedSessions.includes(id)) {
      onSelectionChange(selectedSessions.filter((sid) => sid !== id));
    } else {
      onSelectionChange([...selectedSessions, id]);
    }
  };

  const handleSelectAll = () => {
    const allIds = sessions.map((s) => s._id);
    onSelectionChange(allIds);
  };

  const handleSelectNone = () => {
    onSelectionChange([]);
  };

  if (loading) return <div>Loading sessions...</div>;
  if (!sessions.length) return <div>No sessions available.</div>;

  return (
    <div className={styles.sessionsBar}>
      <div className={styles.controlButtons}>
        <button
          type="button"
          className={styles.controlButton}
          onClick={handleSelectAll}
        >
          ALL
        </button>
        <button
          type="button"
          className={styles.controlButton}
          onClick={handleSelectNone}
        >
          NONE
        </button>
      </div>

      <div className={styles.centerContainer}>
        <span className={styles.sessionsBarTitle}>Sessions:</span>
        <div className={styles.sessionList}>
          {sessions.map((session) => (
            <button
              key={session._id}
              type="button"
              className={
                selectedSessions.includes(session._id)
                  ? `${styles.sessionButton} ${styles.selected}`
                  : styles.sessionButton
              }
              onClick={() => handleToggle(session._id)}
            >
              {session.session}
            </button>
          ))}
        </div>
      </div>

      {rightElement && (
        <div className={styles.rightElement}>{rightElement}</div>
      )}
    </div>
  );
};

export default SessionsBar;
